import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const functionChain: Example = {
  id: "function-chain",
  title: "Constructor chains",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "[].constructor.constructor(code)() → setTimeout('…') → eval: a 3-deep layer tree",
  explainer:
    "`[].constructor.constructor` is `Function`, reached without naming it. Its body schedules a **string** timer, whose code evals the last stage. Each step is a `codegen` row that reveals a new layer: **layer 1** (Function) → **layer 2** (timer string) → **layer 3** (eval), and the beacon is attributed to layer 3.",
  code,
  expect: golden as Example["expect"],
};
